/* UMOJA painting page: gallery and full screen, variant picking with live price, scale view, delivery dates, add to cart, sticky bar, See it on your wall. */
(function(){
  const root = document.querySelector('[data-upp]');
  if (!root) return;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const variants = JSON.parse($('[data-upp-variants]').textContent);
  const landscape = root.dataset.landscape === '1';
  const lock = on => document.documentElement.classList.toggle('upp-lock', on);

  /* gallery */
  const main = $('[data-upp-main]'), slides = $$('.upp__slide'), thumbs = $$('[data-upp-thumb]'), thumbRow = $('.upp__thumbs');
  const go = i => main.scrollTo({left: i * main.clientWidth, behavior: 'smooth'});
  thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.uppThumb)));
  let raf;
  main.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach((t, k) => t.classList.toggle('on', k === i));
      const a = thumbs[i];
      if (a && thumbRow){ const l = a.offsetLeft - thumbRow.offsetLeft; if (l < thumbRow.scrollLeft || l + a.offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) thumbRow.scrollTo({left: l - 12, behavior: 'smooth'}); }
    });
  }, {passive: true});

  /* full screen */
  const lb = $('[data-upp-lb]'), track = $('[data-upp-lb-track]');
  slides.forEach(sl => sl.addEventListener('click', () => {
    lb.hidden = false; lock(true);
    requestAnimationFrame(() => { track.scrollLeft = track.clientWidth * (+sl.dataset.uppZoom); });
  }));
  const closeLb = () => { lb.hidden = true; lock(false); };
  $('[data-upp-lb-close]').addEventListener('click', closeLb);

  /* variants */
  const form = document.getElementById('uppForm'), idInput = $('[data-upp-id]'), addBtn = $('[data-upp-add]'), msg = $('[data-upp-msg]');
  const optInputs = $$('[data-upp-opt]');
  let current = null;
  function selectedOpts(){
    const o = [];
    optInputs.forEach(i => { if (i.checked) o[+i.dataset.uppOpt - 1] = i.value; });
    return o;
  }
  function frameName(){ const f = optInputs.find(i => i.checked && /frame|canvas/i.test(i.value)); return f ? f.value.toLowerCase() : ''; }
  function frameStyle(name){
    if (/black/.test(name)) return {c:'#151311', w:1};
    if (/silver/.test(name)) return {c:'#bfc1c3', w:1};
    if (/white/.test(name)) return {c:'#efede8', w:1};
    if (/wood/.test(name)) return {c:'#7a5232', w:1};
    if (/gold/.test(name)) return {c:'#b8914e', w:1};
    return {c:'rgba(241,233,220,.35)', w:0};
  }
  function sizeCm(){ const s = optInputs.find(i => i.checked && i.dataset.cm); if (!s) return null; const [a, b] = s.dataset.cm.split('x').map(Number); if (!a || !b) return null; return landscape ? {w: Math.max(a, b), h: Math.min(a, b)} : {w: Math.min(a, b), h: Math.max(a, b)}; }
  function update(){
    const o = selectedOpts();
    current = variants.find(v => v.options.every((x, i) => o[i] === undefined || x === o[i])) || current;
    $$('[data-upp-label]').forEach(l => { const v = o[+l.dataset.uppLabel - 1]; if (!v) return; let s = v.split(' (')[0]; if (landscape && / x /.test(s)) s = s.split(' x ').reverse().join(' x '); l.textContent = s; });
    if (current){
      $('[data-upp-price]').textContent = current.price;
      $('[data-upp-add-price]').textContent = current.price;
      $('[data-upp-bar-price]').textContent = current.price;
      if (idInput) idInput.value = current.id;
      addBtn.disabled = !current.available;
      $('[data-upp-add-label]').textContent = current.available ? 'Add to cart' : 'Sold out';
      const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u);
    }
    scale(); wallFrame(); simChips();
  }
  optInputs.forEach(i => i.addEventListener('change', update));

  /* scale view: the painting above an 87 inch (220 cm) sofa, in centimetres */
  function scale(){
    const svg = $('[data-upp-scale]'), d = sizeCm();
    if (!svg || !d) return;
    const x = 180 - d.w / 2, y = 200 - d.h, f = frameStyle(frameName()), b = f.w ? Math.max(2, d.w * 0.035) : 0;
    const set = (el, a) => Object.entries(a).forEach(([k, v]) => el.setAttribute(k, v));
    set($('[data-upp-clip]'), {x, y, width: d.w, height: d.h});
    set($('[data-upp-scale-img]'), {x, y, width: d.w, height: d.h});
    set($('[data-upp-scale-frame]'), {x: x - b / 2, y: y - b / 2, width: d.w + b, height: d.h + b, 'stroke-width': b || 0.8, stroke: f.c});
    const t = $('[data-upp-scale-dim]');
    if (t){ set(t, {x: 180, y: y + d.h / 2, 'font-size': Math.min(11, d.w / 6.5)}); t.textContent = d.w + ' × ' + d.h + ' cm'; }
  }

  /* size simulator window */
  const sim = $('[data-upp-sim]'), simSizes = $('[data-upp-simsizes]');
  const sizeInputs = optInputs.filter(i => i.dataset.cm);
  if (simSizes) sizeInputs.forEach(i => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'chip'; b.textContent = landscape ? i.value.split(' (')[0].split(' x ').reverse().join(' x ') : i.value.split(' (')[0];
    b.addEventListener('click', () => { i.checked = true; i.dispatchEvent(new Event('change', {bubbles: true})); });
    simSizes.appendChild(b);
  });
  function simChips(){ if (!simSizes) return; [...simSizes.children].forEach((b, k) => b.classList.toggle('on', sizeInputs[k] && sizeInputs[k].checked)); }
  const openSim = $('[data-upp-sim-open]');
  if (openSim) openSim.addEventListener('click', () => { sim.hidden = false; lock(true); scale(); });
  const closeSim = () => { sim.hidden = true; lock(false); };
  if (sim){ $('[data-upp-sim-close]').addEventListener('click', closeSim); sim.addEventListener('click', e => { if (e.target === sim) closeSim(); }); }

  /* delivery dates, computed from today */
  (function eta(){
    const M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const day = n => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
    const one = d => M[d.getMonth()] + ' ' + d.getDate();
    const range = (a, b) => a.getMonth() === b.getMonth() ? M[a.getMonth()] + ' ' + a.getDate() + ' to ' + b.getDate() : one(a) + ' to ' + one(b);
    const c = root.dataset;
    const n = k => parseInt(c[k], 10);
    const els = $$('[data-eta]');
    if (!els.length) return;
    els[0].textContent = one(new Date());
    els[1].textContent = range(day(n('etaA')), day(n('etaB')));
    els[2].textContent = range(day(n('etaC')), day(n('etaD')));
  })();

  /* add to cart: the cart drawer opens on its own */
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (!current || !current.available) return;
    addBtn.disabled = true; msg.textContent = '';
    try {
      const r = await fetch(ROOT + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({items:[{id: current.id, quantity: 1}]})});
      if (!r.ok){ const j = await r.json().catch(() => ({})); msg.textContent = j.description || 'This option is not available right now.'; }
    } catch(x){ msg.textContent = 'Something went wrong. Please try again.'; }
    addBtn.disabled = !current.available;
  });

  /* sticky bar on phones once the main button is out of view */
  const bar = $('[data-upp-bar]');
  if ('IntersectionObserver' in window){
    new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('on', show); bar.setAttribute('aria-hidden', !show); }).observe(addBtn);
  }
  $('[data-upp-bar-add]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : addBtn.click());

  /* See it on your wall */
  const wm = $('[data-upp-wm]'), pick = $('[data-upp-wm-pick]'), stage = $('[data-upp-wm-stage]'), file = $('[data-upp-wm-file]');
  const cv = $('[data-upp-wm-cv]'), bg = $('[data-upp-wm-bg]'), pa = $('[data-upp-wm-pa]'), art = $('[data-upp-wm-art]'), range = $('[data-upp-wm-range]');
  let pos = {x: .5, y: .38};
  function wallFrame(){
    if (!pa) return;
    const f = frameStyle(frameName()), d = sizeCm() || {w: 5, h: 7};
    pa.style.aspectRatio = d.w + ' / ' + d.h;
    pa.style.borderColor = f.w ? f.c : 'transparent';
    pa.style.borderWidth = f.w ? 'max(3px, 3.5%)' : '0';
  }
  function place(){
    pa.style.width = range.value + '%';
    pa.style.left = (pos.x * 100) + '%';
    pa.style.top = (pos.y * 100) + '%';
  }
  $$('[data-upp-wall-open]').forEach(b => b.addEventListener('click', () => { if (sim) sim.hidden = true; wm.hidden = false; lock(true); }));
  const closeWm = () => { wm.hidden = true; lock(false); };
  $('[data-upp-wm-close]').addEventListener('click', closeWm);
  wm.addEventListener('click', e => { if (e.target === wm) closeWm(); });
  file.addEventListener('change', () => {
    const f = file.files && file.files[0];
    if (!f) return;
    bg.onload = () => { pick.hidden = true; stage.hidden = false; if (!art.src) art.src = root.dataset.art; wallFrame(); place(); };
    bg.src = URL.createObjectURL(f);
  });
  range.addEventListener('input', place);
  $('[data-upp-wm-again]').addEventListener('click', () => { stage.hidden = true; pick.hidden = false; file.value = ''; });
  let drag = null;
  pa.addEventListener('pointerdown', e => { drag = {id: e.pointerId}; pa.setPointerCapture(e.pointerId); e.preventDefault(); });
  pa.addEventListener('pointermove', e => {
    if (!drag) return;
    const r = cv.getBoundingClientRect();
    pos.x = Math.min(.98, Math.max(.02, (e.clientX - r.left) / r.width));
    pos.y = Math.min(.98, Math.max(.02, (e.clientY - r.top) / r.height));
    place();
  });
  const end = () => { drag = null; };
  pa.addEventListener('pointerup', end); pa.addEventListener('pointercancel', end);
  $('[data-upp-wm-dl]').addEventListener('click', () => {
    try {
      const W = bg.naturalWidth, H = bg.naturalHeight, k = W / cv.clientWidth;
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const g = c.getContext('2d');
      g.drawImage(bg, 0, 0, W, H);
      const pr = pa.getBoundingClientRect(), cr = cv.getBoundingClientRect();
      const x = (pr.left - cr.left) * k, y = (pr.top - cr.top) * k, w = pr.width * k, h = pr.height * k;
      const bw = parseFloat(getComputedStyle(pa).borderLeftWidth) * k;
      g.shadowColor = 'rgba(0,0,0,.35)'; g.shadowBlur = 18 * k; g.shadowOffsetY = 6 * k;
      g.fillStyle = bw ? getComputedStyle(pa).borderLeftColor : '#000';
      g.fillRect(x, y, w, h);
      g.shadowColor = 'transparent';
      const iw = art.naturalWidth, ih = art.naturalHeight, tw = w - 2 * bw, th = h - 2 * bw;
      const s = Math.max(tw / iw, th / ih), sw = tw / s, sh = th / s;
      g.drawImage(art, (iw - sw) / 2, (ih - sh) / 2, sw, sh, x + bw, y + bw, tw, th);
      c.toBlob(b => { const a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'umoja-on-my-wall.jpg'; a.click(); }, 'image/jpeg', .9);
    } catch(x){ alert('Download is not available on this device. You can take a screenshot instead.'); }
  });
  $('[data-upp-wm-lead]').addEventListener('submit', async e => {
    e.preventDefault();
    const em = e.target.querySelector('input[type=email]').value;
    const fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', em); fd.append('contact[tags]', 'newsletter,wall-preview,' + (root.dataset.handle || ''));
    try { await fetch(ROOT + 'contact', {method:'POST', body: fd}); } catch(x){}
    e.target.querySelector('.nl').hidden = true;
    $('[data-upp-wm-ok]').hidden = false;
  });

  addEventListener('keydown', e => { if (e.key !== 'Escape') return; if (!lb.hidden) closeLb(); if (!wm.hidden) closeWm(); if (sim && !sim.hidden) closeSim(); });
  update();
})();